import { graphql } from '@/generated/gql';

export const DEMAND_MASKING_QUERY = graphql(/* GraphQL */ `
  query DemandMaskingQuery($id: UUID!) {
    tesseract {
      demand(id: $id) {
        id
        competitiveBiddingRule {
          id
          isMaskedBidding
        }
      }
    }
  }
`);

export const NEGOTIATION_CASE_MASKING_QUERY = graphql(/* GraphQL */ `
  query NegotiationCaseMaskingQuery($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        isMaskedBidding
      }
    }
  }
`);
